import { render } from "./NavigationDesktop.vue?vue&type=template&id=658edf26&scoped=true"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js"

import "./NavigationDesktop.vue?vue&type=style&index=0&id=658edf26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658edf26"]])

export default __exports__